import { registerMcpServerValidators } from './validators/mcpServerValidators';

registerMcpServerValidators();

export const fields = {
  id: {},
  name: {
    label: 'Name',
    rules: 'required|uniqueMcpServerName',
    placeholder: 'e.g. Jira, Netbox, ServiceNow'
  },
  description: {
    label: 'Description',
    placeholder: 'What this MCP server provides and when AI Advisor should use it'
  },
  url: {
    label: 'MCP Server URL',
    rules: 'required|url|regex:/^https:/i',
    messages: {
      regex: 'MCP server URLs must use https.'
    },
    placeholder: 'https://example.com/mcp'
  },
  credential_name: {
    label: 'Custom Headers (optional)'
  },
  auth_type: {
    label: 'Authentication',
    defaultValue: 'headers',
    options: [
      { label: 'HTTP Headers', value: 'headers' },
      { label: 'OAuth', value: 'oauth' }
    ]
  },
  oauth_client_id: {
    label: 'Client ID (public)',
    placeholder: 'Pre-registered public client ID, when the provider has no automatic registration'
  },
  oauth_auth_url: {
    label: 'Authorization URL',
    rules: 'url|regex:/^https:/i',
    messages: {
      regex: 'OAuth URLs must use https.'
    },
    placeholder: 'https://provider.com/oauth/authorize'
  },
  oauth_token_url: {
    label: 'Token URL',
    rules: 'url|regex:/^https:/i',
    messages: {
      regex: 'OAuth URLs must use https.'
    },
    placeholder: 'https://provider.com/oauth/token'
  },
  oauth_revocation_url: {
    label: 'Revocation URL (optional)',
    rules: 'url|regex:/^https:/i',
    messages: {
      regex: 'OAuth URLs must use https.'
    },
    placeholder: 'https://provider.com/oauth/revoke'
  },
  oauth_scopes: {
    label: 'Scopes',
    placeholder: 'read write (space-separated)'
  },
  type: {
    label: 'Type',
    defaultValue: 'public',
    options: [
      { label: 'Public', value: 'public' },
      { label: 'Private', value: 'private' }
    ]
  },
  enabled: {
    label: 'Enabled',
    defaultValue: true
  },
  requires_approval: {
    label: 'Requires approval',
    defaultValue: false
  }
};
